// this file is generated by update_shopify_store_data.py at 2026-02-23 20:31:00.652529
var courses = [];